
export const handleSocialClick = (platform: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'social_link_click', {
      event_category: 'engagement',
      event_label: `Footer Social Click - ${platform}`,
      platform: platform,
      location: 'footer'
    });
  }
};

export const handleNavClick = (section: string, item: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'footer_nav_click', {
      event_category: 'navigation',
      event_label: `Footer Navigation Click - ${section} - ${item}`,
      section: section,
      item: item,
      location: 'footer'
    });
  }
};

export const handleOfficialDownloadClick = () => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'official_download_click', {
      event_category: 'conversion',
      event_label: 'Google Play Store Download',
      download_type: 'official',
      location: 'footer'
    });
  }
};

export const handleLegalClick = (page: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'legal_page_click', {
      event_category: 'navigation',
      event_label: `Legal Page Click - ${page}`,
      page: page,
      location: 'footer'
    });
  }
};

export const handleWinnersCircleClick = () => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'external_link_click', {
      event_category: 'conversion',
      event_label: 'The Winners Circle Website',
      destination: 'thewinnerscircle.io',
      utm_source: 'frontrunner',
      utm_medium: 'website',
      utm_campaign: 'footer',
      location: 'footer'
    });
  }
};
